<template>
  <nav class="app-header" style="z-index: 3">
    <v-toolbar color="#FAF9F7" height="60" style="border-bottom: 1px solid #000000;">
      <!-- <v-img
        alt="Logo"
        class="shrink app"
        contain
        src="@/assets/Sundae_Logo.png"
        transition="scale-transition"
        width="110"
      /> -->
      <label
        class="hidden-sm-and-down"
        style="color: #231F20; margin-left: 30px; font-size: 30px; font-family: 'Mrs Eaves Small Caps OT', serif;"
      >
        parking redemption management
      </label>
      <v-spacer></v-spacer>
      <div class="project-site-nav__actions">
        <button
          type="button"
          class="project-site-nav__language"
          :aria-label="`Change language. Current language: ${$i18n.locale}`"
          @click="toggleLanguage()"
        >
          <img
            src="@/assets/icons/globalicon.png"
            alt=""
            class="project-site-nav__globe"
          />
          <span
            :class="{ 'project-site-nav__language--active': $i18n.locale === 'th' }"
          >
            TH
          </span>
          <span class="project-site-nav__language-divider">/</span>
          <span
            :class="{ 'project-site-nav__language--active': $i18n.locale === 'en' }"
          >
            EN
          </span>
          <img
            src="@/assets/icons/arrowdown.png"
            alt=""
            class="project-site-nav__chevron"
          />
        </button>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="project-site-nav__user"
              v-bind="attrs"
              v-on="on"
            >
              <span class="project-site-nav__username">{{ Username }}</span>
              <span
                class="project-site-nav__user-chevron"
                aria-hidden="true"
              ></span>
            </button>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in itemsMenu" :key="index">
              <v-list-item-title
                style="cursor: pointer"
                @click="ActionMenu(item)"
                >{{ item.title }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>

    <v-dialog v-model="EditUserDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <p>{{ $t("message.ChangePassword") }}</p>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            icon
            @click="CloseEditUserDialog()"
          >
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <p style="font-size: 13px; color: black">{{ $t("message.Username") }}</p>
              <v-text-field
                disabled
                outlined
                dense
                :placeholder="$t('message.Username')"
                v-model="Username"
              />
            </v-col>
            <v-col cols="12" md="6">
              <p style="font-size: 13px; color: black">{{ $t("message.OldPassword") }}</p>
              <v-text-field
                outlined
                dense
                :placeholder="$t('message.OldPassword')"
                type="password"
                id="oldpassword"
                v-model="EditOldPassword"
                :append-icon="flagOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="TogglePassword"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <p style="font-size: 13px; color: black">{{ $t("message.NewPassword") }}</p>
              <v-text-field
                outlined
                dense
                :placeholder="$t('message.NewPassword')"
                type="password"
                id="newpassword"
                v-model="EditPassword"
                :append-icon="flagPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="ToggleNewPassword"
              />
            </v-col>
            <v-col cols="12" md="6">
              <p style="font-size: 13px; color: black">{{ $t("message.ConfirmNewPassword") }}</p>
              <v-text-field
                outlined
                dense
                :placeholder="$t('message.ConfirmNewPassword')"
                type="password"
                id="confirmpassword"
                v-model="EditConfirmPassword"
                :append-icon="flagConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="ToggleConfirmPassword"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="12" align="center">
              <v-btn
                height="40"
                width="150"
                color="success"
                @click="ChangePassword()"
              >
                {{ $t("message.Submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  data() {
    return {
      url: enurl.apiUrl,
      Username: this.$cookies.get("Username"),
      StatusAdmin: false,

      EditUserDialog: false,
      flagOldPassword: false,
      flagPassword: false,
      flagConfirmPassword: false,

      itemsMenu: [],

      EditUsername: "",
      EditOldPassword: "",
      EditPassword: "",
      EditConfirmPassword: "",

      projectName: "",
    };
  },

  mounted() {
    let self = this;
    self.GetDataPermission();
  },

  methods: {
    ActionMenu(data) {
      let self = this;
      switch (data.id) {
        case 1:
          self.$router.push("/ManageUser");
          break;
        case 2:
          self.ManageRole();
          break;
        case 3:
          self.$router.push("/ManageQuotaRate");
          break;
        case 4:
          self.EditUser();
          break;
        case 5:
          self.Logout();
          break;
      }
    },

    EditUser() {
      let self = this;
      let token = localStorage.getItem("Token");
      self.GetDataUserByToken(token);
    },

    ManageRole(){
      let self = this;
      self.$router.push("/ManageRole");
    },

    GetDataPermission() {
      let self = this;
      axios
        .get(`${self.url}Permission/getDataMenuPermission`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.StatusAdmin = response.data.data.manageUser;
            self.itemsMenu = [];
            // if (response.data.data.manageUser == true) {
            //   self.itemsMenu.push({
            //     title: "Manage User",
            //     id: 1,
            //   });
            // }
            // if (response.data.data.manageUser == true) {
            //   self.itemsMenu.push({
            //     title: "Manage Role",
            //     id: 2,
            //   });
            // }
            // if(response.data.data.manageUser == true){
            //   self.itemsMenu.push({
            //     title: "Manage Quota Rate",
            //     id: 3,
            //   });
            // }
            self.itemsMenu.push({
              title: "Change Password",
              id: 4,
            });
            self.itemsMenu.push({ title: "Logout", id: 5 });
          }
        })
        .catch(function (error) {
          console.warn(error);
        }).finally(() => {
          self.LoadingDialog = false;
        });
    },

    GetDataUserByToken(token) {
      let self = this;
      let temp = {
        token: token,
      };
      axios
        .post(`${self.url}Login/GetDataUserByToken`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.MappingEditUser(response.data.data);
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            text:
              error?.response?.data?.message ||
              error?.message ||
              String(error),
          });
        });
    },

    ChangePassword(){
      let self = this;
      if(self.EditPassword != self.EditConfirmPassword){
        Swal.fire({
            icon: "error",
            width: 900,
            text: "กรุณากรอก Password ให้ถูกต้องและตรงกัน",
          });
      }
      self.LoadingDialog = true;
      let temp = {
        oldPassword: self.EditOldPassword,
        newPassword: self.EditPassword
      };
      axios
        .post(`${self.url}Login/ChangePassword`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.Logout();
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    MappingEditUser(data) {
      let self = this;
      self.EditUsername = data.username;
      self.EditUserDialog = true;
    },

    CloseEditUserDialog() {
      let self = this;
      self.EditOldPassword = "";
      self.EditPassword = "";
      self.EditConfirmPassword = "";
      self.EditUserDialog = false;
    },

    TogglePassword() {
      let self = this;
      var x = document.getElementById("oldpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagOldPassword = false;
      } else {
        x.type = "password";
        self.flagOldPassword = true;
      }
    },

    ToggleNewPassword() {
      let self = this;
      var x = document.getElementById("newpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagPassword = false;
      } else {
        x.type = "password";
        self.flagPassword = true;
      }
    },

    ToggleConfirmPassword() {
      let self = this;
      var x = document.getElementById("confirmpassword");
      if (x.type === "password") {
        x.type = "text";
        self.flagConfirmPassword = false;
      } else {
        x.type = "password";
        self.flagConfirmPassword = true;
      }
    },

    Logout() {
      let self = this;
      self.$store
        .dispatch("Logout")
        .then(function () {
          self.$router.push("/Login");
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    toggleLanguage() {
      this.GetDataPermission();
      this.$i18n.locale = this.$i18n.locale === "en" ? "th" : "en";
    },

  },
};
</script>
<style>
.app {
  margin-left: 1rem;
  cursor: pointer;
}
.list {
  cursor: pointer;
}
.apptitle {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.v-list-item__content {
  font-family: "Roboto", sans-serif;
  font-size: 20px !important;
}
.mdi-menu-down::before {
  color: black;
}
.white-color {
  background-color: red;
  color: red;
}
.item-title {
  font-size: 16px;
  font-weight: 500;
}
.project-site-nav__actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.project-site-nav__language,
.project-site-nav__user {
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Mrs Eaves Small Caps OT", serif;
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}
.project-site-nav__language {
  min-width: 154px;
  padding: 0 10px;
  gap: 7px;
  color: #777373;
  background-color: #ffffff;
  border: 1px solid #8b8785;
  border-radius: 18px;
}
.project-site-nav__language--active {
  color: #231f20;
}
.project-site-nav__language-divider {
  color: #231f20;
}
.project-site-nav__globe {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
  margin-right: 1px;
}
.project-site-nav__chevron {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
  margin-left: 3px;
}
.project-site-nav__user {
  width: 100.97px;
  min-width: 100.97px;
  max-width: 100.97px;
  height: 29.17px;
  padding: 0 8px;
  gap: 8px;
  color: #ffffff;
  background-color: #555051;
  border: 0;
  border-radius: 18px;
}
.project-site-nav__username {
  width: 60px;
  line-height: 1;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
}
.project-site-nav__user-chevron {
  width: 12.12px;
  height: 8.75px;
  flex-shrink: 0;
  background-color: #faf9f7;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
.project-site-nav__language:focus-visible,
.project-site-nav__user:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 2px;
}
@media (max-width: 600px) {
  .project-site-nav__actions {
    gap: 8px;
  }
  .project-site-nav__language {
    min-width: 128px;
    padding: 0 8px;
    gap: 5px;
    font-size: 16px;
  }
  .project-site-nav__user {
    font-size: 16px;
  }
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  .v-list-group__items
  .v-list-item {
  padding-left: 20px !important;
}
@font-face {
  font-family: "Mrs Eaves Small Caps OT";
  src: url("~@/assets/Font/SmallCaps.otf") format("opentype");
  font-style: normal;
  font-weight: normal;
  font-display: swap;
}
</style>
